export default __webpack_public_path__ + "static/media/gold.590370b8.png";